import { useFieldCatalog } from 'features/charts-v2/hooks/use-field-catalog'
import { useIsEnhancedDialect } from 'features/charts-v2/hooks/use-is-enhanced-dialect'
import type { YogiQLChartsService } from 'features/charts-v2/service/yogiql-service'
import type { FieldCatalogResponse } from 'features/charts-v2/types/yogiql'

export { yogiqlFieldCatalogKey } from 'features/charts-v2/hooks/use-field-catalog'

/** The hub's field catalog, fetched only when the hub flag is on (or the
 *  caller forces the YogiQL route) and the caller opted in; undefined until it
 *  loads. The chart specs are the client's own (`YOGIQL_CHART_SPECS`). */
export const useYogiQLRegistry = (
  service: YogiQLChartsService,
  projectId: string | null,
  optIn: boolean,
  force = false,
): {
  enhancedDialect: boolean
  flagSettled: boolean
  catalog: FieldCatalogResponse | undefined
  settled: boolean
} => {
  const { enabled: enhancedDialect, settled: flagSettled } =
    useIsEnhancedDialect()
  const { catalog, settled } = useFieldCatalog(
    service,
    projectId,
    (enhancedDialect || force) && optIn,
    force ? 'the chart is not drawn' : 'using the legacy query',
  )
  return { enhancedDialect, flagSettled, catalog, settled }
}
